import { useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const LowBatteryDetails = ({
  className = "",
  lowBatteryDetailsBackgroundColor,
  lowBatteryDetailsPadding,
  rectangleDivBackgroundColor,
  device12LowBattery1,
  lastInteractionPadding,
  myCaBMy,
  cuTLnCui,
  blankLineColor,
  pin18FontFamily,
  pin18FontSize,
  blankLineFontFamily,
  blankLineFontSize,
  cuTLnCuiFontFamily,
  xemLchSFontSize,
  xemLchSFontFamily,
}) => {
  const lowBatteryDetailsStyle = useMemo(() => {
    return {
      backgroundColor: lowBatteryDetailsBackgroundColor,
      padding: lowBatteryDetailsPadding,
    };
  }, [lowBatteryDetailsBackgroundColor, lowBatteryDetailsPadding]);

  const rectangleDivStyle = useMemo(() => {
    return {
      backgroundColor: rectangleDivBackgroundColor,
    };
  }, [rectangleDivBackgroundColor]);

  const lastInteractionStyle = useMemo(() => {
    return {
      padding: lastInteractionPadding,
    };
  }, [lastInteractionPadding]);

  const blankLineStyle = useMemo(() => {
    return {
      color: blankLineColor,
    };
  }, [blankLineColor]);

  const pin18Style = useMemo(() => {
    return {
      fontFamily: pin18FontFamily,
    };
  }, [pin18FontFamily]);

  const pin181Style = useMemo(() => {
    return {
      fontSize: pin18FontSize,
    };
  }, [pin18FontSize]);

  const blankLine1Style = useMemo(() => {
    return {
      fontFamily: blankLineFontFamily,
    };
  }, [blankLineFontFamily]);

  const blankLine2Style = useMemo(() => {
    return {
      fontSize: blankLineFontSize,
    };
  }, [blankLineFontSize]);

  const cuTLnCuiStyle = useMemo(() => {
    return {
      fontFamily: cuTLnCuiFontFamily,
    };
  }, [cuTLnCuiFontFamily]);

  const xemLchSStyle = useMemo(() => {
    return {
      fontSize: xemLchSFontSize,
      fontFamily: xemLchSFontFamily,
    };
  }, [xemLchSFontSize, xemLchSFontFamily]);

  const navigate = useNavigate();

  const onDevice12LowBatteryClick = useCallback(() => {
    navigate("/41-setting-wifi");
  }, [navigate]);

  const onMyCaBClick = useCallback(() => {
    navigate("/41-history-5");
  }, [navigate]);

  return (
    <div
      className={`self-stretch rounded-xl bg-light-pink flex flex-row items-end justify-start py-[22px] px-5 box-border gap-5 max-w-full text-left text-3xs text-dark-text font-text-regular-lowercase mq360:flex-wrap ${className}`}
      style={lowBatteryDetailsStyle}
    >
      <div
        className="h-40 w-[360px] relative rounded-xl bg-light-pink hidden max-w-full"
        style={rectangleDivStyle}
      />
      <img
        className="w-[116px] relative max-h-full object-cover cursor-pointer z-[1] mq360:flex-1"
        loading="lazy"
        alt=""
        src={device12LowBattery1}
        onClick={onDevice12LowBatteryClick}
      />
      <div
        className="flex flex-col items-start justify-end pt-0 px-0 pb-[9px] box-border min-w-[175px] mq360:flex-1"
        style={lastInteractionStyle}
      >
        <div className="self-stretch h-[97px] relative">
          <div
            className="absolute top-[0px] left-[0px] leading-[120%] flex items-center w-full h-full cursor-pointer z-[1]"
            onClick={onMyCaBClick}
          >
            <span className="w-full">
              <p className="m-0 text-lg">
                <span className="whitespace-pre-wrap">
                  <span className="font-semibold">{myCaBMy}</span>
                </span>
              </p>
              <p className="m-0">
                <span className="whitespace-pre-wrap">
                  <span className="whitespace-pre-wrap" style={blankLineStyle}>
                    <span className="whitespace-pre-wrap">&nbsp;</span>
                  </span>
                </span>
              </p>
              <p className="m-0 text-light-text">
                <span className="whitespace-pre-wrap" style={pin18Style}>
                  <span className="whitespace-pre-wrap" style={pin181Style}>
                    <span>Pin 18%</span>
                  </span>
                </span>
              </p>
              <p className="m-0 text-dark-pink">
                <span className="whitespace-pre-wrap" style={blankLine1Style}>
                  <span className="whitespace-pre-wrap" style={blankLine2Style}>
                    <span>&nbsp;</span>
                  </span>
                </span>
              </p>
              <p className="m-0 text-sm">
                <span>
                  <span className="whitespace-pre-wrap" style={cuTLnCuiStyle}>
                    <span>{cuTLnCui}</span>
                  </span>
                </span>
              </p>
              <p className="m-0">
                <span>
                  <span className="font-semibold whitespace-pre-wrap">
                    &nbsp;
                  </span>
                </span>
              </p>
              <p className="m-0">
                <span>
                  <span
                    className="font-semibold whitespace-pre-wrap"
                    style={xemLchSStyle}
                  >
                    {" "}
                    Xem lịch sử nói chuyện
                  </span>
                </span>
              </p>
            </span>
          </div>
          <img
            className="absolute top-[87px] left-[0px] w-[9px] h-[9px] overflow-hidden z-[2]"
            loading="lazy"
            alt=""
            src="/calendar-month.svg"
          />
        </div>
      </div>
    </div>
  );
};

LowBatteryDetails.propTypes = {
  className: PropTypes.string,
  device12LowBattery1: PropTypes.string,
  myCaBMy: PropTypes.string,
  cuTLnCui: PropTypes.string,

  /** Style props */
  lowBatteryDetailsBackgroundColor: PropTypes.string,
  lowBatteryDetailsPadding: PropTypes.string,
  rectangleDivBackgroundColor: PropTypes.string,
  lastInteractionPadding: PropTypes.string,
  blankLineColor: PropTypes.string,
  pin18FontFamily: PropTypes.string,
  pin18FontSize: PropTypes.string,
  blankLineFontFamily: PropTypes.string,
  blankLineFontSize: PropTypes.string,
  cuTLnCuiFontFamily: PropTypes.string,
  xemLchSFontSize: PropTypes.string,
  xemLchSFontFamily: PropTypes.string,
};

export default LowBatteryDetails;
